import { registrationAnalytics } from 'modules/registration/analytics';
import { paymentCompleteActions } from 'modules/registration/actions/paymentCompleteActions';
import { RegistrationStatus, RegistrationStepEnum } from 'modules/registration/constants';
import { registrationService } from 'modules/registration/services';
import { currentPaymentStore, stepperStore } from 'modules/registration/stores';
import { parseUrlParams, preloaders } from 'modules/registration/utils';
import { registrationLeaderEmailExistsErrorUtil } from 'modules/registration/validations';

const MAX_POLL_COUNT = 5;
/**
 * Stop waiting for a pending registration after about 2 minutes
 */
const MAX_PENDING_POLL_COUNT = 120;
let pollCount = 0;
let pendingPollCount = 0;

const STATUS_NAMES = {
  [RegistrationStatus.pending]: 'pending',
  [RegistrationStatus.completed]: 'completed',
  [RegistrationStatus.canceled]: 'failed',
};

export const checkStripeRedirect = async () => {
  const { registrationComplete: uuid, paymentStatus } = parseUrlParams();

  if (!uuid) {
    return;
  }
  const response = await registrationService.checkRegistrationStatus(uuid);

  if (response.isOk) {
    const status = response.data?.data?.status;

    if (pollCount === 0 && pendingPollCount === 0) {
      registrationAnalytics.redirectReturned(paymentStatus, status ? STATUS_NAMES[status] : null);
    }

    stepperStore.init(RegistrationStepEnum.confirmation);
    currentPaymentStore.setRegistrationStatus(status || null);
    if (status === RegistrationStatus.completed) {
      registrationLeaderEmailExistsErrorUtil.cleanError();
      registrationAnalytics.completed(uuid, true);
      paymentCompleteActions.success();
      preloaders.loadRegistrationStatus.disable();
    } else if (status === RegistrationStatus.canceled) {
      if (pollCount < MAX_POLL_COUNT) {
        //  Try again, to avoid the bug related with to the user's ability to refuse to pay by card and pay for iDeal
        pollCount += 1;
        setTimeout(checkStripeRedirect, 1000);
      } else {
        paymentCompleteActions.cancel();
        preloaders.loadRegistrationStatus.disable();
      }
    } else if (status === RegistrationStatus.pending) {
      if (pendingPollCount < MAX_PENDING_POLL_COUNT) {
        pendingPollCount += 1;
        setTimeout(checkStripeRedirect, 1000);
      } else {
        registrationAnalytics.statusUnresolved(pendingPollCount);
        paymentCompleteActions.pending();
        preloaders.loadRegistrationStatus.disable();
      }
    }
  }
};
